import React from 'react'

function Sidebar() {
  return (
    <div className='bg-[#3a3053]  absolute rounded-lg top-[7rem] left-4 z-10 h-[24rem] w-[92%]'>
    <ul className='absolute top-8 text-white text-xl flex flex-col gap-4 left-[38%] text-center font-medium '>
        <li>Features</li>
        <li>Pricing</li>
        <li>Resources</li>
    </ul>
    <hr className='w-[80%] h-[.50rem]  absolute top-[11rem] left-[2rem]'/>
     <ul className='absolute top-[14rem] text-white text-xl flex flex-col gap-4 left-[40%] text-center font-medium'>
        <li className='absolute left-[.90rem]'>Login</li>
        <li className='bg-[#2bd1cf] text-center h-[3rem] w-[19rem] top-[4rem] rounded-full pt-2 absolute left-[-7rem] '>Sign Up</li>
     </ul>
    </div>
  )
}

export default Sidebar